// Shared layout for the low-chrome informational pages (contact, privacy,
// terms). Narrow measure, generous leading — these are read, not skimmed.

export function LegalShell({ eyebrow, title, intro, updated, children }) {
  return (
    <div className="container-page py-16 md:py-24">
      <div className="mx-auto max-w-3xl">
        <header>
          {eyebrow && <span className="eyebrow">{eyebrow}</span>}
          <h1 className="section-title mt-3">{title}</h1>
          {intro && <p className="prose-body mt-5 text-lg">{intro}</p>}
          {updated && (
            <p className="mt-6 text-xs uppercase tracking-[0.14em] text-ink-soft/70">
              Last updated {updated}
            </p>
          )}
        </header>
        <div className="mt-12 space-y-10">{children}</div>
      </div>
    </div>
  );
}

export function LegalSection({ heading, children }) {
  return (
    <section>
      <h2 className="font-display text-xl md:text-2xl leading-tight text-ink">{heading}</h2>
      <div className="prose-body mt-3 space-y-3">{children}</div>
    </section>
  );
}

// Bulleted list with the site's ink-soft body colour.
export function LegalList({ items }) {
  return (
    <ul className="mt-3 space-y-2 pl-5">
      {items.map((item, i) => (
        <li key={i} className="list-disc marker:text-sunset-600">{item}</li>
      ))}
    </ul>
  );
}

export const SUPPORT_EMAIL = "support@aloharates.com";

export function SupportLink({ className = "" }) {
  return (
    <a href={`mailto:${SUPPORT_EMAIL}`} className={`text-ocean-700 underline underline-offset-2 hover:text-ocean-900 ${className}`}>
      {SUPPORT_EMAIL}
    </a>
  );
}
